var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _vm.importErrors
        ? _c("div", { staticClass: "alert errors" }, [
            _c("strong", [_vm._v("The uploaded csv file contains errors:")]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.importErrors, function (errors, row) {
                return _c("li", [
                  _c("strong", [_vm._v("Row #" + _vm._s(row + 1))]),
                  _vm._v(" "),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(errors.join("<br />")) },
                  }),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.savedFormData.multiple
        ? _c(
            "fieldset",
            { staticClass: "form__group" },
            [
              _c("legend", [_vm._v("Create Multiple User Profiles")]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("FileUpload", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: { label: "Upload a CSV file", name: "csv" },
                model: {
                  value: _vm.formData.csv,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "csv", $$v)
                  },
                  expression: "formData.csv",
                },
              }),
              _vm._v(" "),
              _c("FileUpload", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  label: "Upload a ZIP with the profile photos",
                  name: "zip",
                },
                model: {
                  value: _vm.formData.zip,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "zip", $$v)
                  },
                  expression: "formData.zip",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__group form__group--submit" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "wait",
                        rawName: "v-wait:disabled",
                        value: ["submit", "csv uploading", "zip uploading"],
                        expression:
                          '["submit", "csv uploading", "zip uploading"]',
                        arg: "disabled",
                      },
                    ],
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.back.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Back\n\t\t\t")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "wait",
                        rawName: "v-wait:disabled",
                        value: ["submit", "csv uploading", "zip uploading"],
                        expression:
                          '["submit", "csv uploading", "zip uploading"]',
                        arg: "disabled",
                      },
                    ],
                    staticClass: "btn btn--primary",
                  },
                  [_vm._v("Create Users\n\t\t\t")]
                ),
              ]),
            ],
            1
          )
        : _c(
            "fieldset",
            { staticClass: "form__group" },
            [
              _c("legend", [_vm._v("Create a User Profile")]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.firstName,
                      expression: "formData.firstName",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "first-name",
                    required: "",
                    name: "firstName",
                    placeholder: "Enter the user's first name...",
                  },
                  domProps: { value: _vm.formData.firstName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "firstName", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "first-name" } },
                  [_vm._v("First name")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("firstName"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.lastName,
                      expression: "formData.lastName",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "last-name",
                    required: "",
                    name: "lastName",
                    placeholder: "Enter the user's surname...",
                  },
                  domProps: { value: _vm.formData.lastName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "lastName", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "last-name" } },
                  [_vm._v("Surname")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("lastName"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.position,
                      expression: "formData.position",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "position",
                    required: "",
                    name: "position",
                    placeholder: "Enter the user's job title...",
                  },
                  domProps: { value: _vm.formData.position },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "position", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "position" } },
                  [_vm._v("Position")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("position"))),
                ]),
              ]),
              _vm._v(" "),
              _c("FormControlSector", {
                attrs: {
                  label: "Sector specialisations",
                  name: "specialisms",
                  multiple: true,
                },
                model: {
                  value: _vm.formData.specialisms,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "specialisms", $$v)
                  },
                  expression: "formData.specialisms",
                },
              }),
              _vm._v(" "),
              _c("FileUpload", {
                attrs: {
                  id: "avatar",
                  label: "Profile picture",
                  name: "avatar",
                },
                model: {
                  value: _vm.formData.avatar,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "avatar", $$v)
                  },
                  expression: "formData.avatar",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.email,
                      expression: "formData.email",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "email",
                    required: "",
                    name: "email",
                    placeholder: "Enter the user's email address...",
                  },
                  domProps: { value: _vm.formData.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "email", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "email" } },
                  [_vm._v("Email address")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("email"))),
                ]),
              ]),
              _vm._v(" "),
              _c("FormControlOffice", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  label: "Office location",
                  placeholder: "Select one of the company's offices",
                  member: _vm.savedFormData.member,
                  name: "office",
                },
                model: {
                  value: _vm.formData.office,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "office", $$v)
                  },
                  expression: "formData.office",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__group form__group--submit" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "wait",
                        rawName: "v-wait:disabled",
                        value: ["submit", "avatar uploading"],
                        expression: '["submit", "avatar uploading"]',
                        arg: "disabled",
                      },
                    ],
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.back.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Back")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "wait",
                        rawName: "v-wait:disabled",
                        value: ["submit", "avatar uploading"],
                        expression: '["submit", "avatar uploading"]',
                        arg: "disabled",
                      },
                    ],
                    staticClass: "btn btn--primary",
                  },
                  [_vm._v("Create User")]
                ),
              ]),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Upload a CSV file containing grouped information of all the users to automatically create multiple\n\t\t\tprofiles at once. If you need help with the upload, "
      ),
      _c("a", { attrs: { href: "" } }, [
        _vm._v("download the CSV Template here"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }